import { render, staticRenderFns } from "./ask-leave.vue?vue&type=template&id=8773e8e4&scoped=true"
import script from "./ask-leave.vue?vue&type=script&lang=js"
export * from "./ask-leave.vue?vue&type=script&lang=js"
import style0 from "./ask-leave.vue?vue&type=style&index=0&id=8773e8e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8773e8e4",
  null
  
)

export default component.exports